
import { Component, Vue } from "vue-property-decorator";
import { IDefaultShippingOrderModel } from "@/api/types";
import { additionalCosts } from "@/api/factory-packing-list";
import {checkCanPurchaseOrderFee, getAmountDistribution} from "@/api/hq-packing-list";

import Pagination from "@/components/Pagination/index.vue";
import { updatePaymentOrderCheck } from "@/api/supplier-payment";
import { saveAmountDistributionList } from "@/api/customer";

import { getCanOtherManagement } from "@/api/hq-packing-list"

import { putPurchaseOrder } from "@/api/credit-note"
import PurchaseOrderFee from "@/views/hq-packing-list-management/other-expenses-management/components/purchaseOrderFee.vue";
import Template from "@/views/system-management/template/index.vue";
import CreateFee from "@/views/hq-packing-list-management/other-expenses-management/components/CreateFee.vue";
import CreateClaim from "@/views/hq-packing-list-management/other-expenses-management/components/CreateClaim.vue";
import Deposit from "@/views/hq-packing-list-management/other-expenses-management/components/Deposit.vue";

@Component({
  name: "quotationDetails",
  components: {
    Template,
    PurchaseOrderFee,
    Pagination,
    CreateFee,
    CreateClaim,
    Deposit
  }
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showFee = false;
  public shippingOrder: IDefaultShippingOrderModel[] = [];

  private id = "";
  private supplierId = "";
  private hqCode = "";
  private depositParams = {};
  private depositData = [];
  private status = '';

  created() {
    this.id = this.$route.query.hqPackingListId as string || "";
    this.supplierId = this.$route.query.supplierId as string || "";
    this.hqCode = this.$route.query.hqCode as string || "";
    this.status = this.$route.query.status as string || "";
    this.init();

    if(this.$route.query.pageState && this.$route.query.pageState === 'HqPackingList') {
      this.getCanOtherManagement(this.$route.query.hqPackingListId)
    }
    this.checkCanPurchaseOrderFee(this.$route.query.hqPackingListId)
  }

  activated() {
    this.id = this.$route.query.hqPackingListId as string || "";
    this.supplierId = this.$route.query.supplierId as string || "";
    this.hqCode = this.$route.query.hqCode as string || "";
    this.status = this.$route.query.status as string || "";
    this.init();

    if(this.$route.query.pageState && this.$route.query.pageState === 'HqPackingList') {
      this.getCanOtherManagement(this.$route.query.hqPackingListId)
    }
    this.checkCanPurchaseOrderFee(this.$route.query.hqPackingListId)
  }

  private init() {
    this.getAmountDistribution();
  }

  private amountDistributionList = [] as any;
  private async getAmountDistribution() {
    if(this.id) {
      await getAmountDistribution(this.id).then(res => {
        this.amountDistributionList = res
      }).catch(err => {
        console.log(err);
      })
    }
  }

  private updateUseAmount({params,data}) {
    this.depositParams = params;
    this.depositData = [...this.depositData, ...data];
  }

  private handleSuccess() {
    this.showFee = false;
  }

  private async saveAmount () {
    try {
      this.depositLoading = true;
      let params = {
        hqPackingListId: this.id,
        supplierId: this.supplierId
      }
      let depositList = (this.$refs.deposit as any).table.list;
      let data = depositList.map(item => {
        return {
          paymentVoucherId: item.paymentVoucherId,
          useAmount: item.useAmount || 0,
        };
      });
      await saveAmountDistributionList(params,data);
      this.$notify({
        title: "成功",
        message: "分配定金金额保存成功",
        type: "success",
        duration: 2000
      });
    } catch {
      this.$notify({
        title: "失败",
        message: "分配定金金额保存失败",
        type: "error",
        duration: 2000
      });
    } finally {
      this.depositLoading = false;
    }
  }

  private otherFeeLoading = false;
  private claimFormLoading = false;
  private depositLoading = false;

  private async submitForm() {
    this.$confirm("请确认创建费用金额是否正确。如已有付款单，修改金额请通知财务更新付款单！", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      const otherAmount = (this.$refs['otherFees'] as CreateFee).getAmount();
      const claimAmount = (this.$refs['createClaim'] as CreateClaim).getAmount();
      const depositAmount = (this.$refs['deposit'] as Deposit).getAmount();
      const amount = otherAmount - claimAmount - depositAmount;
      let params = {
        hqPackingListId: this.id,
        amount: amount,
      };
      await updatePaymentOrderCheck(params).then(async (res:any) => {
        await this.save();
        if(res === '1') {
          this.$notify({
            title: "提示",
            message: "其他费用已更新，请及时更新装箱单的付款单！",
            type: "warning",
            duration: 2000
          });
        }
      }).catch(err => {
        console.log(err)
      })
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private async save() {
    this.additionalCosts();
    this.saveClaimTable().then(() => {
      (this.$refs['createClaim'] as CreateClaim).getClaimDJ();
    });
    this.saveAmount().then(() => {
      this.getAmountDistribution();
    });
  }

  private async additionalCosts() {
    let paymentVoucherOtherFees = (this.$refs.otherFees as any).table.list;
    let moneys = paymentVoucherOtherFees.map(item => {
      return {
        id: item.id || "",
        typeName: item.typeName?item.typeName[1]:'',
        amount: item.amount,
        remark: item.remark,
        purchaseOrderId: item.purchaseOrderId ?item.purchaseOrderId:null,
        deduction: item.typeName?item.typeName[0] !== "补款":false
      };
    });
    try {
      this.otherFeeLoading = true;
      await additionalCosts(this.id, {
        moneys: moneys
      });
      this.$notify({
        title: "成功",
        message: "其他费用保存成功",
        type: "success",
        duration: 2000
      });
    } catch {
      this.$notify({
        title: "失败",
        message: "其他费用保存失败",
        type: "error",
        duration: 2000
      });
    } finally {
      this.otherFeeLoading = false;
    }
  }
  private getButtonTrue = true
  // 从客人装箱单管理跳转进来的时候要进行获取接口确认是否可以操作（补扣款、索赔、定金）
  private async getCanOtherManagement(id) {
    const res:any = await getCanOtherManagement(id)
    if(res.data === undefined) {
      this.getButtonTrue = res;
      (this.$refs.otherFees as any).btnForFa(res);
      (this.$refs.createClaim as any).btnForFa(res);
    } else {
      this.getButtonTrue = res.data;
      (this.$refs.otherFees as any).btnForFa(res.data);
      (this.$refs.createClaim as any).btnForFa(res.data);
    }
  }

  private canPurchaseOrderFee = false;
  private purchaseOrderFeeLoading = false;
  private async checkCanPurchaseOrderFee(id) {
    this.purchaseOrderFeeLoading = true;
    const res = await checkCanPurchaseOrderFee({ hqPackingListId: id }) as any;
    this.canPurchaseOrderFee = res.data;
    this.purchaseOrderFeeLoading = false;
  }

  private async saveClaimTable() {
    let claimTable = (this.$refs.createClaim as any).table.list;

    let claimDeductionReqList = claimTable.map(item => {
      return {
        claimFormId: item.id,
        deductionAmount: item.deductionAmount || 0,
        remark: item.deductionRemark || ''
      };
    });
    let data = {
      relationDocumentId: this.id,
      relationDocumentCode: this.hqCode,
      relationDocumentType: "HQ_PACKING_LIST",
      claimDeductionReqList
    }

    let claimTableStatus = false

    claimTable.map(it => {
      if(!it.deductionAmount) {
        claimTableStatus = true
      }
    })

    if(claimTableStatus) {
      this.$notify({
        title: "提示",
        message: "索赔抵扣金额不能为0或不填",
        type: "error",
        duration: 2000
      });
    } else {
      this.claimFormLoading = true;
      await putPurchaseOrder(data).then(res => {
        this.$notify({
          title: "成功",
          message: "索赔单据保存成功",
          type: "success",
          duration: 2000
        });
      }).catch(err => {
        this.$notify({
          title: "失败",
          message: "索赔单据保存失败",
          type: "error",
          duration: 2000
        });
      }).finally(() => {
        this.claimFormLoading = false;
      })
    }
  }
}
